module.exports = "<div class=\"d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow\">\r\n  <h5 class=\"my-0 mr-md-auto font-weight-normal\">Time Measurement</h5>\r\n  <div class=\"my-2 my-md-0 mr-md-3\">\r\n\r\n  </div>\r\n</div>\r\n\r\n<div class=\"container-fluid\">\r\n\r\n  <tm-time-measurement></tm-time-measurement>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main